(function () {
  'use strict';

  var RECS_SECTION_ID  = 'aarja-cart-recommendations';
  var RECS_PER_PRODUCT = 4;

  var _initialized = false;
  var _lastProdIds = '';
  var _cachedCards = null; // combined deduped rec cards HTML array

  /* ─── Boot ──────────────────────────────────────────── */
  function init() {
    if (_initialized) return;
    _initialized = true;

    var dialog = document.querySelector('#cart-drawer dialog');
    if (!dialog) return;

    /* Shared close function — closes OFT modal + cart drawer */
    function closeAll() {
      var modalWrap = document.getElementById('acd-oft-wrap');
      if (modalWrap) {
        modalWrap.classList.remove('acd-oft-wrap--open');
        modalWrap.setAttribute('aria-hidden', 'true');
      }
      var themeDrawer = document.getElementById('cart-drawer');
      if (themeDrawer && typeof themeDrawer.close === 'function') {
        themeDrawer.close();
      } else {
        dialog.close();
      }
    }

    /* Backdrop click → close everything */
    var backdrop = document.getElementById('cart-backdrop');
    if (backdrop) {
      backdrop.addEventListener('click', closeAll);
    }

    /* acd-oft-wrap sits above the backdrop and intercepts clicks in that area —
       close everything when clicking the wrap itself (not the inner modal content) */
    var oftWrap = document.getElementById('acd-oft-wrap');
    if (oftWrap) {
      oftWrap.addEventListener('click', function (e) {
        if (e.target === oftWrap) closeAll();
      });
    }

    /* Watch the dialog's `open` attribute — fires on both open AND close */
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'open') {
          if (dialog.hasAttribute('open')) {
            onDrawerOpen();
          } else {
            onDrawerClose();
          }
        }
      });
    });
    observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });

    /* Also fire immediately if the drawer is already open on page load */
    if (dialog.hasAttribute('open')) onDrawerOpen();

    /* Intercept .aarja-pc__form submissions — open cart drawer after add */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('.aarja-pc__form')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      submitPcForm(form);
    }, true);

    /* Selling plan selector inside cart drawer */
    document.addEventListener('change', function (e) {
      if (e.target.matches('.acd-plan-select')) {
        changePlanInCart(e.target);
      }
    });
  }

  /* ─── Selling-plan change ────────────────────────────── */
  function changePlanInCart(select) {
    var key       = select.dataset.key;
    var variantId = parseInt(select.dataset.variantId, 10);
    var quantity  = parseInt(select.dataset.quantity,  10) || 1;
    var newPlanId = parseInt(select.value, 10);

    select.disabled = true;

    /* Step 1 — remove the existing line */
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        /* Step 2 — re-add with the new selling plan */
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: quantity, selling_plan: newPlanId }]
          })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        _lastProdIds = '';
        _cachedCards = null;
        refreshDrawerContents();
      })
      .catch(function (err) {
        console.error('[ACD Plan] change error', err);
        select.disabled = false;
      });
  }

  /* ─── Product-card form add-to-cart ─────────────────── */
  function submitPcForm(form) {
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          /* Shopify returned an error */
          if (btn) btn.disabled = false;
          return;
        }
        /* Invalidate recs cache so fresh recs fetch on next open */
        _lastProdIds = '';
        _cachedCards = null;

        /* Open the cart drawer, then refresh its contents */
        openCartDrawer();
        refreshDrawerContents();
      })
      .catch(function (err) {
        console.error('[ACD PC] add error', err);
        if (btn) btn.disabled = false;
      });
  }

  function openCartDrawer() {
    var themeDrawer = document.getElementById('cart-drawer');
    /* Use the theme-drawer component's own open() method — handles animations,
       focus management and modal vs. panel mode automatically. */
    if (themeDrawer && typeof themeDrawer.open === 'function') {
      themeDrawer.open();
      return;
    }
    /* Fallback: open the dialog directly */
    var dialog = document.querySelector('#cart-drawer dialog');
    if (dialog && !dialog.hasAttribute('open')) {
      window.matchMedia('(max-width: 989px)').matches
        ? dialog.showModal()
        : dialog.show();
    }
  }

  function refreshDrawerContents() {
    fetch('/?sections=cart-drawer-section', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer-section'];
        if (!html) return;

        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        /* Swap the inner cart content */
        var newInner = tmp.querySelector('[data-hydration-key="cart-drawer-inner"]');
        var oldInner = document.querySelector('[data-hydration-key="cart-drawer-inner"]');
        if (newInner && oldInner) {
          oldInner.innerHTML = newInner.innerHTML;
        }

        /* Update item count badge in drawer head */
        var newCount = tmp.querySelector('#acd-count');
        var oldCount = document.getElementById('acd-count');
        if (newCount && oldCount) oldCount.textContent = newCount.textContent;

        /* Fresh recs needed after cart contents changed */
        _lastProdIds = '';
        _cachedCards = null;

        /* Trigger recs for the updated cart */
        onDrawerOpen();
      })
      .catch(function (err) {
        console.error('[ACD PC] refresh error', err);
      });
  }

  /* ─── On drawer open ────────────────────────────────── */
  function onDrawerOpen() {
    /* Show black page overlay */
    var backdrop = document.getElementById('cart-backdrop');
    if (backdrop) backdrop.classList.add('cart-backdrop--visible');

    /* Re-read product IDs from the data attribute (updated with each SRA re-render) */
    var comp = document.querySelector('cart-drawer-component');
    var ids  = comp ? (comp.dataset.productIds || '') : '';

    /* Skip if nothing changed and we already have results */
    if (ids === _lastProdIds && _cachedCards !== null) {
      injectCards(_cachedCards);
      return;
    }

    _lastProdIds = ids;
    _cachedCards = null;

    var productIds = ids.split(',').filter(Boolean);
    if (!productIds.length) return;

    fetchRecsForAll(productIds);
  }

  /* ─── On drawer close ───────────────────────────────── */
  function onDrawerClose() {
    /* Hide black page overlay */
    var backdrop = document.getElementById('cart-backdrop');
    if (backdrop) backdrop.classList.remove('cart-backdrop--visible');

    /* Hide OFT modal */
    var modalWrap = document.getElementById('acd-oft-wrap');
    if (modalWrap) {
      modalWrap.classList.remove('acd-oft-wrap--open');
      modalWrap.setAttribute('aria-hidden', 'true');
    }
  }

  /* ─── Fetch recommendations for every product in cart ─ */
  function fetchRecsForAll(productIds) {
    var promises = productIds.map(function (id) {
      return fetchRecsForProduct(id);
    });

    Promise.all(promises)
      .then(function (resultsPerProduct) {
        /* Merge all rec cards, deduplicate by product_id, exclude cart products */
        var seen     = {};
        var combined = [];

        /* Mark cart products as already seen so they can't appear in recs */
        productIds.forEach(function (id) { seen[id] = true; });

        resultsPerProduct.forEach(function (cards) {
          cards.forEach(function (card) {
            var pid = card.productId;
            if (!seen[pid]) {
              seen[pid] = true;
              combined.push(card.html);
            }
          });
        });

        _cachedCards = combined;
        injectCards(combined);
      })
      .catch(function (err) {
        console.error('[ACD OFT] fetch error', err);
      });
  }

  /* Fetch recommendations for a single product; returns array of { productId, html } */
  function fetchRecsForProduct(productId) {
    var url = '/recommendations/products'
      + '?section_id=' + RECS_SECTION_ID
      + '&product_id=' + productId
      + '&limit='      + RECS_PER_PRODUCT
      + '&intent=related';

    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp       = document.createElement('div');
        tmp.innerHTML = html;

        /* The section renders inside <div id="shopify-section-..."> */
        var wrapper = tmp.querySelector('[id^="shopify-section-"]') || tmp;

        /* Each child of wrapper is a .acd-rec-card element */
        var cards = [];
        Array.from(wrapper.children).forEach(function (el) {
          var pid = el.dataset.productId;
          if (pid) cards.push({ productId: pid, html: el.outerHTML });
        });
        return cards;
      })
      .catch(function () { return []; });
  }

  /* ─── Inject cards into desktop modal + mobile track ── */
  function injectCards(htmlArray) {
    var combined = htmlArray.join('');

    /* Desktop OFT modal */
    var modalList = document.getElementById('acd-oft-modal-list');
    var modalWrap = document.getElementById('acd-oft-wrap');
    if (modalList && modalWrap) {
      modalList.innerHTML = combined;
      if (htmlArray.length > 0) {
        modalWrap.classList.add('acd-oft-wrap--open');
        modalWrap.removeAttribute('aria-hidden');
      } else {
        modalWrap.classList.remove('acd-oft-wrap--open');
        modalWrap.setAttribute('aria-hidden', 'true');
      }
    }

    /* Mobile inline track */
    var inlineTrack = document.getElementById('acd-oft-inline-track');
    var inlineWrap  = document.getElementById('acd-oft-inline');
    if (inlineTrack && inlineWrap) {
      inlineTrack.innerHTML = combined;
      if (htmlArray.length > 0) {
        inlineWrap.removeAttribute('hidden');
      } else {
        inlineWrap.setAttribute('hidden', '');
      }
    }

    /* Re-attach add-to-cart listeners on newly injected cards */
    bindAddButtons();
  }

  /* ─── Add-to-cart for rec cards ─────────────────────── */
  function bindAddButtons() {
    [
      document.getElementById('acd-oft-modal-list'),
      document.getElementById('acd-oft-inline-track')
    ].forEach(function (container) {
      if (!container) return;
      container.querySelectorAll('.acd-rec-card__add').forEach(function (btn) {
        /* Remove old listener to prevent duplicates */
        btn.replaceWith(btn.cloneNode(true));
      });
      container.querySelectorAll('.acd-rec-card__add').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var variantId = btn.dataset.variantId;
          if (!variantId) return;
          addToCart(variantId, btn);
        });
      });
    });
  }

  function addToCart(variantId, btn) {
    btn.disabled    = true;
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type':    'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          btn.textContent = (window.Theme && window.Theme.translations && window.Theme.translations.addPlus) || 'Add +';
          btn.disabled    = false;
          return;
        }
        btn.textContent = (window.Theme && window.Theme.translations && window.Theme.translations.addedConfirmation) || '✓ Added';
        refreshCartSection();
      })
      .catch(function () {
        btn.textContent = (window.Theme && window.Theme.translations && window.Theme.translations.addPlus) || 'Add +';
        btn.disabled    = false;
      });
  }

  /* Refresh the cart drawer via Section Rendering API */
  function refreshCartSection() {
    fetch('/?sections=cart-drawer-section', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer-section'];
        if (!html) return;

        var tmp       = document.createElement('div');
        tmp.innerHTML = html;

        /* Update the cart-drawer inner content */
        var newInner = tmp.querySelector('[data-hydration-key="cart-drawer-inner"]');
        var oldInner = document.querySelector('[data-hydration-key="cart-drawer-inner"]');
        if (newInner && oldInner) {
          oldInner.innerHTML = newInner.innerHTML;
        }

        /* Invalidate cache so recs re-fetch with new cart state */
        _lastProdIds = '';
        _cachedCards = null;
      })
      .catch(function (err) {
        console.error('[ACD OFT] refresh error', err);
      });
  }

  /* ─── Boot ──────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
